export const sidebar = {
  header: {
    menu: "MENÜ",
  },
  items: {
    home: "Start",
    reservations: "Buchungen",
    calendar: "Kalender",
    hourlyCalendar: "Stundenweise",
    calls: "Anrufe",
    aiReception: "KI-Rezeption",
    availabilityRates: "Verfügbarkeit & Tarife",
    checkins: "Check-ins",
    channels: "Buchungskanäle",
    inbox: "Posteingang",
    settings: "Einstellungen",
    experiences: "Erlebnisse",
    scheduleCall: "Termin vereinbaren",
    support: "Support",
    novedades: "Neuigkeiten",
    messages: "Nachrichten",
    badgeNew: "Neu",
    invoicing: "Rechnungswesen",
    customers: "Kunden",
    clientsDirectory: "Kunden",
    fiscalCustomers: "Steuerkunden",
    invoices: "Rechnungen",
    housekeeping: "Reinigung",
    analytics: "Auswertungen",
  },
  alt: {
    logo: "Logo",
  },
};
